export enum SDK_MODE {
  all = 'ALL',
  onlyGuestForm = 'ONLY_GUEST_FORM',
  onlyIV = 'IV_ONLY',
  propertyLink = 'PROPERTY_LINK',
  guestRegistrationOnly = 'GUEST_REGISTRATION_ONLY',
  qrIVOnProperty = 'QR_IV_ON_PROPERTY',
}
